export default {"src":"/_next/static/media/checkbox_round.eccc91dd.svg","height":46,"width":45};